import styled from "styled-components";

/* At least one screen tall, so the fixed bar sits at the bottom (as the flow's other steps) */
export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - var(--app-bottom-nav-height, 0px));

  /* The global reset gives every element the system font: these screens are Inter */
  &,
  & * {
    font-family: Inter, sans-serif;
  }
`;
